import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { CustomTranslatePipe } from '@pipes/translate/translate.pipe';

@Component({
  selector: 'app-ketto-assured',
  standalone: true,
  imports: [
    AsyncPipe,
    CustomTranslatePipe
  ],
  templateUrl: './ketto-assured.component.html',
  styleUrls: ['./ketto-assured.component.scss']
})
export class KettoAssuredComponent {



  // assuredClickLisner(e) {
  //   const _el: HTMLElement = e.currentTarget.children[1];
  //   _el.classList.toggle('show-assured-popover');
  // }

}
